import { useRef } from 'react';
import { Group, Input, InputWrapper, InputWrapperProps } from '@mantine/core';
import { PrivateInformationBirthdateType } from '../../../../hooks';
import { handleChange } from './helpers';
import { BirthdateInputUnionType } from './helpers/common';
import classes from './BirthdateInput.module.css';

type BirthdateInputProps = {
  value: PrivateInformationBirthdateType;
  setValue: (value: PrivateInformationBirthdateType) => void;
} & InputWrapperProps;

export const BirthdateInput: React.FC<BirthdateInputProps> = ({
  value,
  setValue,
  label,
  ...props
}) => {
  const dayInputRef = useRef<HTMLInputElement>(null);
  const monthInputRef = useRef<HTMLInputElement>(null);
  const yearInputRef = useRef<HTMLInputElement>(null);

  const onChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    inputType: BirthdateInputUnionType
  ) => {
    const inputValue = event.target.value;

    handleChange({
      inputValue,
      previousValue: value,
      setValue,
      inputType,
      monthInputRef,
      yearInputRef,
    });
  };

  return (
    <InputWrapper label={label} {...props}>
      <Group gap={5} align="end">
        <Input
          ref={dayInputRef}
          onChange={(event) => onChange(event, 'DAY')}
          defaultValue={value.day ?? ''}
          inputMode="numeric"
          maxLength={2}
          className={classes.inputDay}
          placeholder="DD"
          aria-label={`${label}-day`}
        />
        .
        <Input
          ref={monthInputRef}
          onChange={(event) => onChange(event, 'MONTH')}
          defaultValue={value.month ?? ''}
          inputMode="numeric"
          maxLength={2}
          className={classes.inputMonth}
          placeholder="MM"
          aria-label={`${label}-month`}
        />
        .
        <Input
          ref={yearInputRef}
          onChange={(event) => onChange(event, 'YEAR')}
          defaultValue={value.year ?? ''}
          inputMode="numeric"
          maxLength={4}
          className={classes.inputYear}
          placeholder="YYYY"
          aria-label={`${label}-year`}
        />
      </Group>
    </InputWrapper>
  );
};
